import { createSelector } from 'reselect';

import createShadowPurchaseFromPurchase from '../utils/ordering/createShadowPurchaseFromPurchase';

import getStagedPurchases from './getStagedPurchases';

export default createSelector([getStagedPurchases], enhancedStagedPurchases => {
  return (enhancedStagedPurchases || []).map(createShadowPurchaseFromPurchase);
});
